import _classCallCheck from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/landing/landing/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Camera } from './Camera.js';

var OrthographicCamera = /*#__PURE__*/function (_Camera) {
  _inherits(OrthographicCamera, _Camera);

  var _super = _createSuper(OrthographicCamera);

  function OrthographicCamera() {
    var _this;

    var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
    var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var top = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var bottom = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : -1;
    var near = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0.1;
    var far = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2000;

    _classCallCheck(this, OrthographicCamera);

    _this = _super.call(this);
    _this.type = 'OrthographicCamera';
    _this.zoom = 1;
    _this.view = null;
    _this.left = left;
    _this.right = right;
    _this.top = top;
    _this.bottom = bottom;
    _this.near = near;
    _this.far = far;

    _this.updateProjectionMatrix();

    return _this;
  }

  _createClass(OrthographicCamera, [{
    key: "copy",
    value: function copy(source, recursive) {
      _get(_getPrototypeOf(OrthographicCamera.prototype), "copy", this).call(this, source, recursive);

      this.left = source.left;
      this.right = source.right;
      this.top = source.top;
      this.bottom = source.bottom;
      this.near = source.near;
      this.far = source.far;
      this.zoom = source.zoom;
      this.view = source.view === null ? null : Object.assign({}, source.view);
      return this;
    }
  }, {
    key: "setViewOffset",
    value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
      if (this.view === null) {
        this.view = {
          enabled: true,
          fullWidth: 1,
          fullHeight: 1,
          offsetX: 0,
          offsetY: 0,
          width: 1,
          height: 1
        };
      }

      this.view.enabled = true;
      this.view.fullWidth = fullWidth;
      this.view.fullHeight = fullHeight;
      this.view.offsetX = x;
      this.view.offsetY = y;
      this.view.width = width;
      this.view.height = height;
      this.updateProjectionMatrix();
    }
  }, {
    key: "clearViewOffset",
    value: function clearViewOffset() {
      if (this.view !== null) {
        this.view.enabled = false;
      }

      this.updateProjectionMatrix();
    }
  }, {
    key: "updateProjectionMatrix",
    value: function updateProjectionMatrix() {
      var dx = (this.right - this.left) / (2 * this.zoom);
      var dy = (this.top - this.bottom) / (2 * this.zoom);
      var cx = (this.right + this.left) / 2;
      var cy = (this.top + this.bottom) / 2;
      var left = cx - dx;
      var right = cx + dx;
      var top = cy + dy;
      var bottom = cy - dy;

      if (this.view !== null && this.view.enabled) {
        var scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
        var scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
        left += scaleW * this.view.offsetX;
        right = left + scaleW * this.view.width;
        top -= scaleH * this.view.offsetY;
        bottom = top - scaleH * this.view.height;
      }

      this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
      this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
  }, {
    key: "toJSON",
    value: function toJSON(meta) {
      var data = _get(_getPrototypeOf(OrthographicCamera.prototype), "toJSON", this).call(this, meta);

      data.object.zoom = this.zoom;
      data.object.left = this.left;
      data.object.right = this.right;
      data.object.top = this.top;
      data.object.bottom = this.bottom;
      data.object.near = this.near;
      data.object.far = this.far;
      if (this.view !== null) data.object.view = Object.assign({}, this.view);
      return data;
    }
  }]);

  return OrthographicCamera;
}(Camera);

OrthographicCamera.prototype.isOrthographicCamera = true;
export { OrthographicCamera };